import React, { useContext, useEffect, useState } from "react";
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import GlobalContext from './../../contexts/GlobalContext';
import Page from './../../components/Page/Page';
import Box from './../../components/Box/Box';

import API, { ResponseManagement, ErrorManagement } from './../../API';
import Utility from './../../Utility';
import StepAccount from './../../components/Account/StepAccount/StepAccount';
// import FormAccount from '../../components/Account/FormAccount';
import FormPersonalInformation from './../../components/Account/FormPersonalInformation/FormPersonalInformation';
import FormAdditionalInformation from './../../components/Account/FormAdditionalInformation/FormAdditionalInformation';
import FormAddressCP from './../../components/Account/FormAddressCP/FormAddressCP';
import FormConnectionAndSetting from './../../components/Account/FormConnectionAndSetting/FormConnectionAndSetting';
import FormDeleteAccount from './../../components/Account/FormDeleteAccount/FormDeleteAccount';
import { Transition, Segment } from 'semantic-ui-react'
import Auth from './../../Auth';

const AccountPage = (props) => {

  let Params = useParams();
  let navigate = useNavigate();

  let codePage = Params.codePage

  const [globalContext] = useContext(GlobalContext);
  const [codePageState, setCodePageState] = useState(codePage);
  const [isVisible, setIsVisible] = useState(false);
  const [animation, setAnimation] = useState('slide right');
  const [durationState, setDurationState] = useState(500);
  const [redirectState, setRedirectState] = useState({
    url : '',
    redirect : false
  });
  const [hasBookingCheckInState, setHasBookingCheckInState] = useState({
    hasBookingCheckIn : false,
    isloaded : false
  });

  

  // test recup info has résa checkin

  useEffect(() => {

    let dataForLink = {
      establishmentId: globalContext.establishment.id,
    };
    // 
    if (!hasBookingCheckInState.isloaded) {
      API.post(Utility.getUrlAjax() + `/hasBookingCheckin`, JSON.stringify(dataForLink) )
      .then(response => {
        ResponseManagement(response,
          () => {
            if (response.data.success) {
              setHasBookingCheckInState({
                hasBookingCheckIn: response.data.data.hasBookingCheckIn, 
                isloaded: true 
              });
            }
            else{
              setHasBookingCheckInState({hasBookingCheckIn: false, isloaded: false })
            }
          },
          () => {
            setHasBookingCheckInState({hasBookingCheckIn: false, isloaded: false })
          }
        );
      })
      .catch(error => {
        setHasBookingCheckInState({hasBookingCheckIn: false, isloaded: false })
        ErrorManagement(error, () => {}, globalContext.translations);
      })
      .finally(() => {
        //setLoading(false)
        //handleModal({cancelBookingModal: false})
      })
    }

    /*if(Auth.isAuthenticatedViaPassword() === false) {
      Auth.logout();
    } else {*/
      /*if( typeof props.match.params.codePage == 'undefined' ){
        props.match.params.codePage = 'personalInformation';
      }*/
      setCodePageState(codePage);
      setIsVisible(true);
    //}
  }, [codePage])


  useEffect(() => {
    Utility.getHeaderPage('account', globalContext.translations)
  }, [globalContext.translations]);

  const handleChangePage = (codePage, sens) => {
    if (codePage !== codePageState) {
      const listAnimSens = {
        before: [
          {
            anim: 'slide left',
            duree: 250,
            visible: false
          },
          {
            anim: 'slide right',
            duree: 500,
            visible: true
          }
        ],
        after: [
          {
            anim: 'slide right',
            duree: 250,
            visible: false
          },
          {
            anim: 'slide left',
            duree: 500,
            visible: true
          }
        ]
      }

      const configAnimation = listAnimSens[sens];

      getAnimation(configAnimation[0]);
      let duree = configAnimation[0].duree;
      if(codePage === 'connectionAndSetting' || codePage === 'deleteAccount') {
        duree = 500;
      }
      let timeout = setTimeout(() => {
        setCodePageState(codePage);
        getAnimation(configAnimation[1]);
        navigate(Utility.getUrlPage(globalContext, codePage));
        window.clearTimeout(timeout);
      }, duree);
    }
  }

  const getAnimation = (sens) => {
    setIsVisible(sens.visible);
    setDurationState(sens.duree);
    setAnimation(sens.anim);
  }

  const getPage = () => {
    let page;
    
    switch (codePageState) {
      case 'deleteAccount':
        page = <FormDeleteAccount />
        break;
      case 'personalInformation':
        page = <FormPersonalInformation handleChangePage={handleChangePage} hasBookingCheckInState={hasBookingCheckInState}/>
        break;
      case 'additionalInformation':
        page = <FormAdditionalInformation hasBookingCheckInState={hasBookingCheckInState}/>
        break;
      case 'addressCP':
        page = <FormAddressCP handleChangePage={handleChangePage} hasBookingCheckInState={hasBookingCheckInState}/>
        break;
      default:
        page = <FormConnectionAndSetting handleChangePage={handleChangePage}/>
        break;
    }
    return page;
  }

  return (
    (redirectState.redirect === true) ? (
      <Navigate to={redirectState.url} />
    ) : (
      <Page location={props.location} history={navigate}>
        <Box message={false} header={Utility.getHeaderPage('account', globalContext.translations)}>
          <StepAccount handleChangePage={handleChangePage} codePage={codePageState} />
          <Transition visible={isVisible} animation={animation} duration={durationState}>
            <Segment>
              {getPage()}
            </Segment>
          </Transition>
        </Box>
      </Page>
    )
  )
}

export default AccountPage;